module.exports = __webpack_public_path__ + "male-icon.1ca9c117598cd2aeb895.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/assets/images/male-icon.svg
// module id = ../../../../../src/assets/images/male-icon.svg
// module chunks = main